<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="label">
        <label>
          {{$t('text_content.documents.files_count')}}: <span class="font-weight-bold">{{filesCount}}</span>
        </label>
      </div>
      <div class="d-flex button-group actions-btns">
        <input enctype="multipart/form-data" type="file" ref="selectFiles" @change="loadFiles" multiple>
        <b-button class="btn btn-warning" @click="chooseFiles" size="sm">
          {{$t('buttons.documents.load_files')}}
        </b-button>
        <b-button class="btn btn-danger" @click="deleteFile" :disabled="!selectedFile" size="sm">
          {{$t('buttons.documents.delete_file')}}
        </b-button>
        <b-button class="btn btn-success" @click="openSelectedFile" :disabled="!selectedFile" size="sm">
          {{$t('buttons.documents.open_file')}}
        </b-button>
      </div>
    </div>
    <ul class="files-wrapper" :style="{height: isCollapse ? 'calc(100vh - 575px)' : 'calc(100vh - 300px)'}">
      <li v-for="item in documents" class="file" :key="item.id" @click="toggleFile(item)"
          :class="{'selected-file': selectedFile && item.id === selectedFile.id}">
        <icon name="file"></icon>
        <span>{{item.filename}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { getFile } from '@/helpers/commonHelpers';
  import { saveAs } from 'file-saver';
  import {notificationsRenderer} from "@/helpers/renderHelpers";

  export default {
    props: ['documents', 'url', 'isCollapse'],
    data() {
      return {
        selectedFile: null
      }
    },
    methods: {
      toggleFile(selectedFile) {
        if (this.selectedFile && selectedFile.id === this.selectedFile.id) {
          this.selectedFile = null;
        } else {
          this.selectedFile = selectedFile;
        }
      },
      chooseFiles() {
        this.$refs['selectFiles'].click();
      },
      async loadFiles() {
        const files = this.$refs['selectFiles'].files;
        if (files.length) {
          for (let i = 0; i < files.length; ++i) {
            const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Content-Disposition': `form-data; filename=${encodeURIComponent(files[i].name)}`
            };
            const data = await getFile(files[i])
            const requestBody = {
              'content': data.base64StringFile,
              'fileType': data.fileType
            };
            try {
              const response = await this.$http.post(this.url, JSON.stringify(requestBody), {headers});
              // if (i === files.length - 1) {
              //   await this.$emit('loadDocuments');
              // }
            } catch (e) {
              notificationsRenderer(e.data, 'error');
            }
          }
        }
        await this.$emit('loadDocuments');
      },
      async deleteFile() {
        try {
          const response = await this.$http.delete(`${this.url}${this.selectedFile.id}/`);
          await this.$emit('loadDocuments');
          this.$refs['selectFiles'].value = '';
          this.selectedFile = null;
        } catch (e) {
          notificationsRenderer(e.data, 'error');
        }
      },
      async openSelectedFile() {
        try {
          const response = await this.$http.get(`${this.url}${this.selectedFile.id}/`);
          const content = response.body.content;
          const uri = `data:${response.body['file_type']};base64,${content}`;
          const file = await fetch(uri);
          const blob = await file.blob();
          saveAs(blob, response.body['file_name']);
        } catch (e) {
          notificationsRenderer(e.data, 'error');
        }
      }
    },
    computed: {
      filesCount() {
        return this.documents.length;
      }
    }
  }
</script>

<style scoped>
  .label {
    padding-top: 8px;
  }

  .actions-btns {
    margin-top: 9px;
  }

  .files-wrapper {
    min-height: 250px;
    list-style-type: none;
    padding: 6px;
    border: 1px solid grey;
    background-color: #F6F6F6;
  }

  input[type='file'] {
    display: none;
  }

  .file {
    float: left;
    width: 200px;
    height: 25px;
    line-height: 25px;
    cursor: pointer;
    padding: 0 1em;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .selected-file {
    background-color: #b0e0e6;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Documents.vue